// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V1Hd","top":"styles_top__3C5rv"};